import React from "react";

const Gold = () => {
  return (
    <svg
      width="15"
      viewBox="0 0 197 209"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.652 53.4809L108.657 13.4828C107.033 9.37085 102.386 7.36285 98.2749 8.98685C96.2193 9.80285 94.5876 11.4268 93.7798 13.4828L77.7842 53.4809C77.0244 55.3849 77.0244 57.4968 77.7842 59.4008L93.7798 99.3988C95.4035 103.511 100.05 105.519 104.162 103.895C106.217 103.079 107.849 101.455 108.657 99.3988L124.652 59.4008C125.404 57.4958 125.404 55.3849 124.652 53.4809Z"
        fill="#815929"
        fillOpacity="0.8"
      />
      <path
        d="M116.654 45.4809L100.658 5.48285C99.0347 1.37085 94.3877 -0.637153 90.2766 0.986847C88.221 1.80285 86.5893 3.42685 85.7815 5.48285L69.7859 45.4809C69.0261 47.3849 69.0261 49.4968 69.7859 51.4008L85.7815 91.3988C87.4052 95.5108 92.0522 97.5189 96.1623 95.8949C98.2178 95.0789 99.8495 93.4548 100.657 91.3988L116.653 51.4008C117.406 49.4968 117.406 47.3849 116.654 45.4809Z"
        fill="#F0CA2E"
      />
      <path
        d="M100.658 91.3989L116.654 51.4009C117.414 49.4969 117.414 47.3849 116.654 45.4809L100.658 5.4829C99.4586 2.4429 93.22 5.4829 93.22 16.4419V96.4379C96.4913 96.4389 99.4426 94.4469 100.658 91.3989Z"
        fill="#D6B534"
        fillOpacity="0.94"
      />
      <path
        d="M174.934 144.373L135.34 127.401C131.285 125.642 126.579 127.508 124.82 131.563C123.944 133.593 123.938 135.896 124.821 137.921L141.793 177.514C142.602 179.398 144.096 180.891 145.979 181.7L185.573 198.672C189.628 200.432 194.334 198.566 196.093 194.511C196.969 192.48 196.975 190.178 196.092 188.153L179.12 148.559C178.304 146.681 176.812 145.188 174.934 144.373Z"
        fill="#815929"
        fillOpacity="0.8"
      />
      <path
        d="M163.621 144.372L124.028 127.4C119.972 125.64 115.266 127.506 113.508 131.562C112.631 133.592 112.626 135.894 113.508 137.919L130.481 177.513C131.29 179.396 132.783 180.89 134.667 181.699L174.26 198.671C178.316 200.431 183.022 198.565 184.78 194.51C185.656 192.48 185.662 190.177 184.779 188.152L167.807 148.559C166.993 146.68 165.499 145.187 163.621 144.372Z"
        fill="#F0CA2E"
      />
      <path
        d="M184.78 188.152L167.807 148.558C166.998 146.675 165.505 145.181 163.621 144.372L124.028 127.4C121.03 126.099 118.768 132.66 126.517 140.409L183.083 196.975C185.397 194.662 186.075 191.167 184.78 188.152Z"
        fill="#D6B534"
        fillOpacity="0.94"
      />
      <path
        d="M57.297 183.646L74.2693 144.053C76.0288 139.997 74.1628 135.291 70.1074 133.533C68.0769 132.656 65.7748 132.651 63.7498 133.533L24.1564 150.506C22.2727 151.315 20.7793 152.808 19.9703 154.692L2.99802 194.285C1.23849 198.341 3.10455 203.047 7.15989 204.805C9.19039 205.682 11.4925 205.687 13.5175 204.805L53.1109 187.832C54.9896 187.017 56.4823 185.524 57.297 183.646Z"
        fill="#815929"
        fillOpacity="0.8"
      />
      <path
        d="M57.2982 172.334L74.2705 132.74C76.03 128.685 74.164 123.979 70.1087 122.22C68.0782 121.344 65.7761 121.338 63.751 122.221L24.1576 139.193C22.274 140.002 20.7806 141.495 19.9715 143.379L2.99924 182.973C1.23971 187.028 3.10576 191.734 7.1604 193.492C9.1909 194.368 11.493 194.374 13.518 193.491L53.1115 176.519C54.9901 175.705 56.4835 174.212 57.2982 172.334Z"
        fill="#F0CA2E"
      />
      <path
        d="M13.5187 193.492L53.1121 176.52C54.9958 175.711 56.4892 174.217 57.2982 172.334L74.2705 132.74C75.5718 129.742 69.0108 127.48 61.2616 135.23L4.69585 191.795C7.0083 194.109 10.5038 194.788 13.5187 193.492Z"
        fill="#D6B534"
        fillOpacity="0.94"
      />
    </svg>
  );
};

export default Gold;
